<template>
  <transition name="bounce">
    <b-container class="py-5 mt-5 custom-container container">
      <b-row align-v="center" align-h="center" class="mt-5 pt-5">
        <b-col
          cols="12"
          class="px-5 mb-5 text-center justify-center align-content-center"
        >
          <b-img
            fluid
            :src="require('@/assets/images/iap-cancelled.svg')"
            alt="Account Upgrade Success image"
          ></b-img>
        </b-col>
        <b-col
          cols="12"
          class="px-5 text-center justify-center align-content-center"
        >
          <h2 class="mb-5 font-weight-bold">
            Your have cancelled your Premium Subscription
          </h2>
          <!-- <b-button
            :to="{ name: 'premium.subscription' }"
            size="lg"
            variant="primary"
            class="h-auto px-5 py-3"
          >
            View subscription packages
          </b-button> -->
          <b-button
            size="lg"
            variant="primary"
            class="h-auto px-5 py-3"
            @click="redirectToSubscription"
          >
            View subscription packages
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </transition>
</template>

<script>
export default {
  name: 'IAPCancelledPage',

  methods: {
    redirectToSubscription() {
      this.$emit('redirectToSubscription')
    }
  }
}
</script>

<style lang="scss" scoped></style>
